// extracted by mini-css-extract-plugin
export default {"button":"styles_button__-l0ih","button_text":"styles_button_text__uH7dO"};